export const checkNameIsAnonymous = (name: string) => {
  return name === 'isAnonymous '
}
